var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      on: {
        click: function($event) {
          return _vm.selectProvider(_vm.provider)
        }
      }
    },
    [
      _c("td", [_vm._v(_vm._s(_vm.provider.name))]),
      _vm._v(" "),
      _c("td", [
        _c("img", {
          attrs: { src: _vm.provider.logo, alt: " No logo uploaded." }
        })
      ]),
      _vm._v(" "),
      _c("td", [
        _c("p", [
          _c("b", [_vm._v("Description: ")]),
          _vm._v(_vm._s(_vm.shortDesc))
        ]),
        _vm._v(" "),
        _c("p", [_c("b", [_vm._v("Url: ")]), _vm._v(_vm._s(_vm.provider.url))]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("Year Founded: ")]),
          _vm._v(_vm._s(_vm.provider.year_founded))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1cf082c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1cf082c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/providerRow.vue
// module id = 161
// module chunks = 0